






























import Vue from 'vue'

export default Vue.extend({
  name: 'RadioButton',
  props: {
    ariaSelected: {
      type: Boolean,
      required: false,
      default: false
    },
    ariaDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    hasTitleSlot(): boolean  {
      return !!this.$slots.title
    }
  }
})
